// ============================================================================
// QrCodeParesseux.js : le QR code (qrcode.react) chargé à la demande.
// ============================================================================
// Deux écrans du bundle principal en montrent un, et rarement : l'écran de
// salle (« Scanner pour voter ») et l'enrôlement de la double authentification
// (AramisLogin). Leur import statique mettait la bibliothèque entière (5 Ko gz)
// dans le démarrage de TOUS les utilisateurs (Refonte Mosaïque L6.0,
// 28/09/2026). Même signature que QRCodeSVG ; pendant le chargement, une
// réserve vide de la même taille (aucun saut de mise en page). Les modules
// déjà paresseux (Admin, vote en AG, profil…) gardent leur import direct.
// ============================================================================
import React, { Suspense } from "react";
import { lazyRetry } from "./lazyRetry";

const QRCodeSVGRaw = lazyRetry(() => import("qrcode.react").then((m) => ({ default: m.QRCodeSVG })));

export function QRCodeSVG(props) {
  const cote = Number(props.size) || 128;
  return (
    <Suspense fallback={<span aria-hidden="true" style={{ display: "inline-block", width: cote, height: cote }} />}>
      <QRCodeSVGRaw {...props} />
    </Suspense>
  );
}
